import {
  SET_FUNNEL_STATUS,
  SET_FUNNEL_TYPE,
  SET_LEAD_TO_EDIT,
  SET_NEW_LEAD_ID,
  SET_LEADS,
  SET_ISCHECKEXISTS,
  SET_SEARCH_LEADS,
  SET_RESPONSIBLE,
  SET_WORK_TECH,
  SET_WORK_TYPE,
  SET_ACCOUNTS_OWNERS,
  SET_PROPOSAL_TYPES,
  SET_LEADS_PER_PAGE,
  SET_PAGE_NUMBER,
  SET_OFFSET,
  SET_POPUP_REDMINE,
  SET_POPUP,
  SET_TYPE_OF_POPUP_DATA,
  SET_UPDATE_NEW_LIST_LEADS_REDMINE_POPUP,
} from '../actionTypes';

export default function (state = {
  leads: [],
  isCheckJobExists: null,
  selectedNewLeadId: null,
  funnelStatuses: [],
  funnelType: [],
  workType: [],
  workTech: [],
  responsible: [],
  proposalTypes: [],
  selectedLead: [],
  accountsOwner: [],
  leadsPerPage: '20',
  page: 1,
  offset: 0,
  isPopupRedmineOpened: false,
  isPopupOpened: false,
  isFolderSetter: false,
  savedSearch: [],
  leadsFromRedminePopup: [],
}, actions) {
  switch (actions.type) {
	  case SET_LEADS: {
	  	return {
	  		...state,
			  leads: actions.payload,
		  };
	  }
	  case SET_SEARCH_LEADS: {
      //   console.log('reducer is started');
		  return {
			  ...state,
			  savedSearch: actions.payload,
		  };
	  }
	  case SET_ISCHECKEXISTS: {
      //   console.log(actions.payload)
      return {
        ...state,
        isCheckJobExists: actions.payload,
      };
	  }
	  case SET_FUNNEL_STATUS: {
	  	return {
	  		...state,
			  funnelStatuses: actions.payload,
		  };
	  }
	  case SET_FUNNEL_TYPE: {
	  	return {
	  		...state,
			  funnelType: actions.payload,
		  };
	  }
	  case SET_WORK_TYPE: {
	  	return {
	  		...state,
			  workType: actions.payload,
		  };
	  }
	  case SET_WORK_TECH: {
	  	return {
	  		...state,
			  workTech: actions.payload,
		  };
	  }
	  case SET_RESPONSIBLE: {
      //   console.log(actions.payload);
		  return {
			  ...state,
			  responsible: actions.payload,
		  };
	  }
	  case SET_LEAD_TO_EDIT: {
	  	// console.log(actions.payload);
	  	return {
	  		...state,
			  selectedLead: actions.payload,
		  };
	  }
	  case SET_NEW_LEAD_ID: {
      return {
        ...state,
        selectedNewLeadId: actions.payload,
      };
	  }
	  case SET_ACCOUNTS_OWNERS: {
	  	return {
	  		...state,
			  accountsOwner: actions.payload,
		  };
	  }
	  case SET_PROPOSAL_TYPES: {
	  	return {
	  		...state,
			  proposalTypes: actions.payload,
		  };
	  }
	  case SET_LEADS_PER_PAGE: {
	  	return {
	  		...state,
			  leadsPerPage: actions.payload,
		  };
	  }
	  case SET_PAGE_NUMBER: {
	  	return {
	  		...state,
			  page: actions.payload,
		  };
	  }
	  case SET_OFFSET: {
	  	return {
	  		...state,
			  offset: actions.payload,
		  };
	  }
	  case SET_POPUP_REDMINE: {
		  return {
			  ...state,
			  isPopupRedmineOpened: !state.isPopupRedmineOpened,
		  };
	  }
	  case SET_UPDATE_NEW_LIST_LEADS_REDMINE_POPUP: {
      //   console.log(actions.payload);
		  return {
			  ...state,
			  leadsFromRedminePopup: actions.payload,
		  };
	  }
	  case SET_POPUP: {
	  	return {
	  		...state,
			  isPopupOpened: !state.isPopupOpened,
		  };
	  }
	  case SET_TYPE_OF_POPUP_DATA: {
	  	return {
	  		...state,
			  isFolderSetter: actions.payload,
		  };
	  }
	  default: {
	  	return state;
	  }
  }
}
